import React, { useContext } from "react";
import EntryBrandingContext from "../features/entryFlow/entryBrandingContext";
import { LangSwitcher, T } from "../hooks/useLanguage";
import LanguageIcon from "../images/icon-language.png";
import "../styles/entry-language-footer.scss";

export default function EntryLanguageFooter({ entryShell = false }) {
  const { active } = useContext(EntryBrandingContext);
  if (active && !entryShell) return null;
  return (
    <div className="entry-language-footer">
      <img src={LanguageIcon} alt="" aria-hidden="true" />
      <T>home.language</T>
      <LangSwitcher />
    </div>
  );
}
